export default "__VITE_ASSET__WLRs9JIe__"